'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Euclidean rhythm based on Bresenham
 * https://gist.github.com/crashingbooth/e9f0b7dbec8aecabf13db3663d28480f
 * euclidean(3, 8); // [1, 0, 0, 1, 0, 0, 1, 0]
 * @function
 * @param {number} hits hits/onsets e.g. 5
 * @param {number} totalSteps total number of steps e.g. 16
 * @param {rotation} rotation rotate to left or right, default is 0
 * @returns {array}
 */
function euclidean(hits, totalSteps, rotation = 0) {
  const slope = hits / totalSteps;
  let result = [];
  let previous;
  for (let i = 0; i < totalSteps; i += 1) {
    const current = parseInt(i * slope, 0);
    result.push(current !== previous ? 1 : 0);
    previous = current;
  }
  // left rotations
  if (rotation < 0) {
    result = result.concat(result.splice(0, Math.abs(rotation)));
  }
  // right rotations
  if (rotation > 0) {
    result = result.concat(result.splice(0, Math.abs(totalSteps - rotation)));
  }
  // no rotation
  return result;
}

/**
 * Get dotted note length
 */
function isDottedNote(note) {
  const dottedRegexp = /[0-9]+\./;
  return dottedRegexp.test(note);
}

/**
 * Build Rhythm based on formula
 * Based on note lengths
 * 1 -> whole note
 * 2 -> half note
 * 2. -> dotted half
 * 4 -> quarter
 * 8 -> eigth note
 * 16 -> sixteenth note
 * @function
 * @param {array} formula formula array e.g. [6, 4, 6, 4]
 * @param {number} bpm beats per minute e.g 60
 * @returns {array}
 */
function build(formula = [4, 4, 4, 4], bpm = 60) {
  // for time signature 4/4, 60 bpm
  // 1-> 4 seconds
  // 2 -> 2 seconds
  // 2. -> 3 seconds
  // 4 -> 1 seconds(1000ms)
  // 4. -> 1 + 0.5 seconds -> 1.5 seconds (1500ms)
  // 8 -> 0.5 seconds
  // 16 -> 0.25 seconds
  // 16. -> 0.25 + 0.125 -> 0.375
  // 1 minute / bpm
  // delay time in ms
  const delayTimeForQuaterNote = 60 / bpm;
  const result = formula.map((noteLength) => {
    if (noteLength === 0) return 0;
    const parsedNoteLength = Math.abs(parseInt(noteLength, 0));
    let delay = delayTimeForQuaterNote * (4 / parsedNoteLength) * 1000;
    if (isDottedNote(noteLength)) {
      delay *= 1.5;
    }
    return delay;
  });
  return result;
}

exports.build = build;
exports.euclidean = euclidean;
exports.isDottedNote = isDottedNote;
